import {
  AssemblyTemplateField,
  DefectLegend,
  GetStructureDetailsQuery,
  PointOfInterestTemplate,
  QuerySummaryItem,
} from '@/__generated__/graphql';
import { SnackbarMessage } from '@/types';
import { atom } from 'jotai';

export const selectedPOIType = atom<Partial<PointOfInterestTemplate> | undefined>(undefined);

export const structureDefectLegends = atom<DefectLegend[] | undefined>(undefined);

export const snackbarMessage = atom<SnackbarMessage>({ shouldShow: false });

export const selectedTemplateId = atom<string | undefined>(undefined);

export const assemblyFields = atom<AssemblyTemplateField[] | undefined>(undefined);

export const selectedTemplateField = atom<AssemblyTemplateField | undefined>(undefined);

export const querySummaries = atom<QuerySummaryItem[] | undefined>(undefined);

export const selectedQuerySummary = atom<QuerySummaryItem | undefined>( undefined);

export const selectedStructure = atom<GetStructureDetailsQuery['structure'] | undefined>(undefined);
